import { render, staticRenderFns } from "./NavbarLayout.vue?vue&type=template&id=dcd12b82&"
import script from "./NavbarLayout.vue?vue&type=script&lang=js&"
export * from "./NavbarLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports